import Carousel from './carousel'

class Program {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.container = document.querySelector('.is-program-header')

      this.carousel = new Carousel('.swiper.is-program', {
        freeMode: true,
        edgeSwipeDetection: 'prevent',
        slidesPerView: 'auto',
        spaceBetween: 6,
        navigation: {
          nextEl: '.swiper-button-program.is-next',
          prevEl: '.swiper-button-program.is-prev',
        },
      })

      if (!this.container) return

      this.initScrollButtons()
    })
  }

  initScrollButtons() {
    this.container.addEventListener('click', (event) => {
      const target = event.target.closest('.button[data-date]')

      if (target) {
        const heading = document.querySelector(
          '.is-scroll-heading[data-date="' + target.dataset.date + '"]'
        )

        if (heading) {
          heading.scrollIntoView({
            behavior: 'smooth',
          })
        }
      }
    })
  }

  getCarousel() {
    return this.carousel
  }
}

const program = new Program()
export default program
